<mat-form-field [appearance]="appearance" [class]="fieldClass">
  @if (label) { <mat-label>{{ label }}</mat-label> }
  @let kwValue = currentValue;
  @if (kwValue) {
    <mat-icon matIconPrefix class="copy-icon" (click)="copy(kwValue)" matTooltip="Copy to clipboard" role="button" tabindex="0">content_copy</mat-icon>
  }
  <input matInput [formControlName]="name" [matTooltip]="kwValue" [matTooltipDisabled]="!kwValue" matTooltipPosition="above" />
</mat-form-field>
